import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=a86568b8&scoped=true&"
import script from "./Configure.vue?vue&type=script&lang=js&"
export * from "./Configure.vue?vue&type=script&lang=js&"
import style0 from "./Configure.vue?vue&type=style&index=0&id=a86568b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86568b8",
  null
  
)

export default component.exports